module.exports = __webpack_public_path__ + "ec.4848ee61ddb7be07b2e1.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ec.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ec.svg
// module chunks = styles